export default __webpack_public_path__ + "static/media/Nuclear Reg Comm (NRC).43432555.png";